<template>
  <div :class="['group-151', className]">
    <div
      v-for="i in count"
      :key="i"
      class="seg"
      :class="{ active: active === i - 1 }"
      @click="select(i - 1)"
    />
  </div>
  </template>

<script>
export default {
  name: "Group151",
  props: {
    className: {
      type: String,
      default: "",
    },
    count: {
      type: Number,
      default: 3,
    },
    active: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    select(i) {
      this.$emit("select", i);
    },
  },
};
</script>

<style>
.group-151 {
  height: 6px;
  width: 244px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.group-151 .seg {
  flex: 1;
  height: 100%;
  border-radius: 3px;
  background: #ffffff33;
  transition: background 200ms ease, transform 200ms ease;
  cursor: pointer;
}

.group-151 .seg.active {
  background: linear-gradient(90deg, #4ad7ff 0%, #3aa0ff 100%);
  box-shadow: 0 0 6px rgba(58, 160, 255, 0.6);
  transform: translateY(-1px);
}
</style>
